module.exports = __webpack_public_path__ + "aef7972ff113f81fc260f923d4266694.jpg";